/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, serverMsg } from '../lib/api.js';
import { GH, GW } from '../lib/config.js';
import { playFanfare } from '../lib/sound.js';

export default {
  onPublish() {
      // Twee dingen die er mis kunnen zijn, en ze brengen je niet naar hetzelfde
      // plekje. Geen account: dan opent het accountscherm op de lijst met namen,
      // of op de velden als je hier nieuw bent. Wel een account maar nog geen
      // kopje: dan meteen in je eigen velden, want daar staat de tekenaar.
      if (!this.ensureName('Log in of maak een account aan om je krabbel op de paal te plakken.')) return;
      if (!/[0-9a-f]/.test(this.state.avatar || '')) {
        this.openAccount('Teken eerst een klein profielfotootje, dan kun je publiceren.');
        return;
      }
      this.setState({
        dialog: 'publish',
        publishTitle: this.state.activeRequest ? this.state.activeRequest.text.slice(0, 40) : '',
        publishIsTheme: false,
        publishError: '', publishing: false
      });
    },

  onTitleInput(e) { return this.setState({ publishTitle: e.target.value }); },

  toggleThemeMatch() { return this.setState((s) => ({ publishIsTheme: !s.publishIsTheme })); },


  async doPublish() {
      // De knop staat uit zolang dit loopt, maar Enter in het titelveld niet.
      if (this.state.publishing) return;
      const title = this.state.publishTitle.trim() || 'Naamloos';
      this.setState({ publishing: true, publishError: '' });
      try {
        const anim = this.animOn() && !this.state.duo;
        const blob = anim ? await this.buildStripBlob() : await this.buildPngBlob();
        if (!blob) throw new Error('Kon de afbeelding niet maken.');
        const fd = new FormData();
        fd.append('title', title);
        fd.append('author', this.state.author);
        fd.append('accountId', this.state.accountId || '');
        fd.append('coAuthorId', this.duoPartnerId() || '');
        fd.append('isThemeMatch', this.state.publishIsTheme ? '1' : '0');
        // Het themawoord van die dag gaat altijd mee, ook als de krabbel niet bij
        // het thema hoort: dan blijft later te zien welk thema er toen gold, wat
        // er ook met de lijst gebeurt.
        fd.append('themeText', this.themeOfDay() || '');
        if (anim) fd.append('frames', String(this.frameCount()));
        fd.append('image', blob, 'tekening.png');
        const res = await api(`${this.state.pbUrl}/api/collections/${this.collectionName}/records`, { method: 'POST', body: fd });
        if (!res.ok) {
          throw new Error(await serverMsg(res));
        }
        if (anim) {
          try {
            const rj = await res.clone().json();
            if (rj && !('frames' in rj) && !this.framesWarned) {
              this.framesWarned = true;
              this.notify('Bewegende krabbels worden nog niet als animatie opgeslagen: voeg in PocketBase een tekstveld "frames" toe aan paal_drawings.');
            }
          } catch (e) {}
          this.stashExtra(this.emptyFrames(), this.emptyOn(), true);
          this.setState({ frames: this.emptyFrames(), frameOn: this.emptyOn(), frameIdx: 0 });
        }
        if (this.canvasRef.current) this.getCtx().clearRect(0, 0, GW, GH);
        if (!this.state.duo) {
          this.savedImage = null;
          /**
           * Het plekje in de projectmap ook leeg, hier en op de server.
           *
           * Alleen `gp_wip` weghalen liet de slot-sleutel en de regel in paal_projects
           * op de geplakte krabbel staan, en een opslag die nog liep schreef hem zelfs
           * opnieuw weg. Bij de volgende start zag fetchProjects een leeg doek hier en
           * een tekening op de server, en zette de al geplakte krabbel terug.
           */
          clearTimeout(this.wipTimer);
          this.stashFirst('');
          const slot = this.state.slot || 0;
          if ((this.state.slotArt || [])[slot]) {
            const art = [...(this.state.slotArt || ['', ''])];
            art[slot] = '';
            this.setState({ slotArt: art });
          }
        }
        this.setState({ sel: null, lassoPts: null });
        this.undoStack = []; this.redoStack = []; this.opBefore = null;
        if (this.state.duo) await this.endDuo();
        if (this.state.activeRequest) {
          let recId = '';
          try { recId = (await res.clone().json()).id || ''; } catch (e) {}
          await this.closeRequest(recId);
        }
        playFanfare();
        const lines = [
          'Wat een plaatje!',
          'Deze pixels zitten goed!',
          'Hier zit werk in, zie ik.',
          'Mooi ding heb je gemaakt.',
          'Deze mag gezien worden!',
          'Kleurtjes op hun plek!'
        ];
        clearTimeout(this.celebrateTimer);
        this.setState({
          publishing: false, dialog: null, undoN: 0, redoN: 0, celebrateReady: false,
          celebrate: { title, line: lines[Math.floor(Math.random() * lines.length)] }
        }, () => {
          this.refreshGallery();
          this.fireConfetti();
          this.celebrateTimer = setTimeout(() => this.setState({ celebrateReady: true }), 1050);
        });
      } catch (err) {
        this.setState({ publishing: false, publishError: 'Publiceren mislukt: ' + err.message });
      }
    }
};
